import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "components/ui/button";

interface LoginSubmitButtonProps {
    submitting: boolean;
}

const LoginSubmitButton: React.FC<LoginSubmitButtonProps> = ({ submitting }) => (
    <Button
        type="submit"
        disabled={submitting}
        palette="indigo"
        size="lg"
        className="h-12 w-full font-nunito text-base shadow-indigo-glow"
    >
        Se connecter
        <ArrowRight className="h-5 w-5" />
    </Button>
);

export default LoginSubmitButton;
